/**
 * Mixin for projects folders components that modify the folders list or navigate within folders
 */
import { mapState, mapActions } from 'vuex'

import { FOLDER_CHILD_ROUTE_NAME, FOLDER_ROUTE_NAME } from '@/router/routerData'
import { LOAD_PROJECTS_FOLDERS_TREE } from '@/store/modules/projects-folders/action_types'
import { GET_PM_ROOMS_PROGRESSIVELY, GET_GUEST_ROOMS_PROGRESSIVELY } from '@/store/modules/rooms/action_types'

export default {
  name: 'projectsFoldersMixin',
  data () {
    return {
      FOLDER_ROUTE_NAME,
    }
  },
  computed: {
    ...mapState('projectsFolders', ['currentProjectsFolder']),
    ...mapState('rooms', ['baseQueryParams']),
  },
  methods: {
    ...mapActions('projectsFolders', [LOAD_PROJECTS_FOLDERS_TREE]),
    ...mapActions('rooms', [GET_PM_ROOMS_PROGRESSIVELY, GET_GUEST_ROOMS_PROGRESSIVELY]),
    navigateToProjectsFolder () {
      let params = {}
      if (this.folder.parentId) {
        params = {
          folderId: this.folder.parentId,
          childId: this.folder.id,
        }
        this.$router.push({ name: FOLDER_CHILD_ROUTE_NAME, params })
      } else {
        params = {
          folderId: this.folder.id,
        }
        this.$router.push({ name: FOLDER_ROUTE_NAME, params })
      }
    },
    updateCurrentAndDestinationFolders (isRoom) {
      // Update current folder
      if (this.currentProjectsFolder.id || isRoom) {
        this.GET_PM_ROOMS_PROGRESSIVELY(this.baseQueryParams.pm)
        this.GET_GUEST_ROOMS_PROGRESSIVELY(this.baseQueryParams.guest)
      } else {
        this.LOAD_PROJECTS_FOLDERS_TREE()
      }

      // Update destination folder
      let destinationFolder = {}
      if (this.folder) { // Drag&drop Folder
        destinationFolder = this.folder
      } else if (this.selectedFolder?.[0]) { // Move Folder Dialog
        destinationFolder = this.selectedFolder[0]
      }

      if (destinationFolder.id || isRoom) {
        this.GET_PM_ROOMS_PROGRESSIVELY(this.baseQueryParams.pm)
        this.GET_GUEST_ROOMS_PROGRESSIVELY(this.baseQueryParams.guest)
      } else {
        this.LOAD_PROJECTS_FOLDERS_TREE()
      }
    },
  },
}
